import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [//一级路由
    {
      path: '/',
      name: 'Login',
      component: () => import('@/views/Login.vue'),
    },
    {
      path: '/index',
      name: 'index',
      component: () => import('@/views/index.vue'),
      children: [//二级路由
        {
          path: '/OverTime',
          name: 'OverTime',
          component: () => import('@/views/pages/OverTime/index.vue')
        },
        {
          path: '/feeOverview',
          name: 'feeOverview',
          component: () => import('@/views/pages/feeOverview/index.vue')
        },
        {
          path: '/employees',
          name: 'employees',
          component: () => import('@/views/pages/employees/index.vue')
        },
       
      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js